import { createWebHistory } from 'vue-router'
import { createApp } from './app'
import './styles/fonts.css'
import './styles/main.css'
import './styles/ui-kit.css'
import './styles/how-to.css'
import './styles/buy.css'
import './styles/header.css'
import './styles/audience.css'
import './styles/game.css'
import './styles/create.css'

const container = document.getElementById('app')
const { app, router } = createApp({ history: createWebHistory(), hydrate: container.hasChildNodes() })
router.isReady().then(() => app.mount(container))
